import React, { Fragment } from 'react';

import {
    customHeaderStyle, defaultPaginationOptions,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle, TableActionIconGeneric
} from "root/Tables/BaseTableComponents";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

const TableProviderDocuments = ( { data, allowDelete, onClick } ) =>
{
    const pdfFormatter = (cell, row, rowIndex, formatExtraData) => {

        let link = '/api/v1.0/src/getFile.php?enc_docid=' + row.enc_doc_id;

        return (
            <Fragment>
                <TableActionIconGeneric href={link} style={{paddingLeft: '20px'}} icon='bi bi-filetype-pdf' color='#3E6C93' text='View PDF Report'/>
                { allowDelete === true && <TableActionIconGeneric onClick={() => onClick ( row.enc_doc_id )} style={{paddingLeft: '10px'}} icon='bi bi-trash3' color='var(--s360-icon-red)' text='Delete Document'/> }
            </Fragment>
        )
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: {...defaultTableHeaderStyles, fontSize: '16px'},
        dmy_date_created: {borderRadius: defaultTopLeftCellStyle, width: "10vw"},
        document_title: {width: "20vw"},
        document_type_description:{width: "15vw"},
        actions: {borderRadius: defaultTopRightCellStyle, width: "5vw"}
    });

    const getColumns = () =>
    {
        let columns = [];

        columns.push({
            dataField: 'dmy_date_created',
            text: 'Date',
            sort: true,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'document_title',
            text: 'Title',
            sort: true,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'document_type_description',
            text: 'Type',
            sort: true,
            headerStyle: headerStyle
        });
        columns.push({
            dataField: 'actions',
            text: 'View',
            formatter: pdfFormatter,
            headerStyle: headerStyle
        });

        return columns;
    }

    const translations = xlateBootstrapTableColumns(getColumns());

    const columns = React.useMemo(() => translations, []);

    const tableContent = () =>
    {
        return <PassportTable data={data.data} isLoading={data.loading} columns={columns} pagination={defaultPaginationOptions} showSearch={true}/>
    }

    return data.loading === true ? <SpinnerDiv/> : tableContent();
}

export default TableProviderDocuments;
